import React from 'react';
import cn from '../../../utils/cn';
import AddressEditModal from './AddressEditModal';
import AddressReset from './AddressReset';
import NoAddressData from './NoAddressData';

// -- Address Row
function AddressRow({ title, data }) {
    return (
        <div className="w-full flex flex-row items-start">
            <p className="w-22 text-sm text-primary/75 capitalize flex-shrink-0 inline-flex items-center justify-between">
                <span>{title}</span>
                <span className="text-primary">:&nbsp;</span>
            </p>
            <p
                className="text-sm text-primary font-normal flex-1"
                style={{
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                }}
            >
                {data}
            </p>
        </div>
    );
}

// -- Address Card
function AddressCard({ title, addressData, disabled }) {
    const { firstName, lastName, organization, email, phone, address, state, city, zip, country } =
        addressData || {};
    // -- check address data and set plus icon
    if (!addressData) {
        return <NoAddressData title={title} data={addressData} disabled={disabled} />;
    }
    // -- If address data is available
    return (
        <div
            className={cn(
                `address-card flex flex-col gap-6 w-full min-h-[250px] p-5 border border-primary-100 rounded-2xl `,
                {
                    'grayscale pointer-events-none': disabled
                }
            )}
        >
            {/* Card Header */}
            <div className="flex flex-row gap-2 justify-between items-end">
                <h1 className="text-primary text-xl font-medium capitalize">{title}</h1>
                <div className="border-b border-primary-200 flex-[1]" />
                <div className="flex flex-row items-center gap-2">
                    <AddressReset data={addressData} />
                    <AddressEditModal data={addressData} title={title} />
                </div>
            </div>
            {/* Card Body */}
            <div className="flex flex-col gap-3">
                <AddressRow title="Organization" data={organization} />
                <AddressRow
                    title="Name"
                    data={[firstName, lastName].filter(Boolean).join(' ') || 'N/A'}
                />
                <AddressRow title="Email" data={email || 'N/A'} />
                <AddressRow title="Phone" data={phone || 'N/A'} />
                <AddressRow
                    title="Address"
                    // data={
                    //     `${addressData?.address}, ${addressData?.state}, ${addressData?.city}, ${addressData?.zip}, ${addressData?.country}`.trim() ||
                    //     `No Address Data`
                    // }
                    data={[address, city, state, zip, country].filter(Boolean).join(', ') || '---'}
                />
            </div>
        </div>
    );
}

export default AddressCard;
